import React, { useEffect } from 'react';

function StatusToast({
  error = '',
  success = '',
  onClearError,
  onClearSuccess,
  durationMs = 3500,
  bottomOffsetClass = 'bottom-[calc(64px+env(safe-area-inset-bottom)+8px)] md:bottom-6',
}) {
  const tone = error ? 'error' : (success ? 'success' : '');
  const message = error || success || '';

  useEffect(() => {
    if (!message) {
      return undefined;
    }

    const timeoutId = setTimeout(() => {
      if (tone === 'error' && typeof onClearError === 'function') {
        onClearError();
      } else if (tone === 'success' && typeof onClearSuccess === 'function') {
        onClearSuccess();
      }
    }, durationMs);

    return () => clearTimeout(timeoutId);
  }, [message, tone, durationMs, onClearError, onClearSuccess]);

  if (!message) {
    return null;
  }

  const toneClasses = tone === 'error'
    ? 'border-red-200 bg-red-50 text-red-700'
    : 'border-emerald-200 bg-emerald-50 text-emerald-700';

  return (
    <div className={`pointer-events-none fixed inset-x-0 z-[140] flex justify-center px-3 ${bottomOffsetClass}`}>
      <div className={`w-full max-w-xl rounded-xl border px-3 py-2 text-sm shadow-lg ${toneClasses}`}>
        <p>{message}</p>
      </div>
    </div>
  );
}

export default StatusToast;
